import React from 'react';

import PropTypes from 'prop-types';

import {
  AutoSuggestList,
  AutoSuggestListItem,
  AutoSuggestSection,
  AutoSuggestSectionTitle,
  TextWithBoldSubString,
} from '~/searchCio/components/sharedComponents/productComponents';
import { QUERY_TYPE_TOP_SUGGESTION } from '~/searchCio/constants/cioConstants';
import useCioAutosuggest from '~/searchCio/hooks/useCioAutosuggest';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import TrendingSearchesSection from './TrendingSearchesSection';

const TopSuggestionsSection = ({ query, suggestions }) => {
  const { handleSearchTermSelect } = useCioAutosuggest();

  if (!suggestions || suggestions.length === 0) {
    return <TrendingSearchesSection />;
  }

  return (
    <AutoSuggestSection data-testid="cnstrc-top-suggestions">
      <AutoSuggestSectionTitle role="heading" id="top_suggestions_title">
        <FormattedMessage
          id="search_autosuggest.top_suggestions_header"
          defaultMessage="Top Suggestions"
        />
      </AutoSuggestSectionTitle>
      <AutoSuggestList aria-labelledby="top_suggestions_title">
        {suggestions.map((searchTerm) => (
          <AutoSuggestListItem
            role="link"
            data-autotag="top_search_list_item"
            key={searchTerm.value}
            tabIndex={0}
            onClick={() => {
              handleSearchTermSelect({
                searchTerm: searchTerm.value,
                queryType: QUERY_TYPE_TOP_SUGGESTION,
              });
            }}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleSearchTermSelect({
                  searchTerm: searchTerm.value,
                  queryType: QUERY_TYPE_TOP_SUGGESTION,
                });
              }
            }}
            data-cnstrc-item-section="Search Suggestions"
          >
            <TextWithBoldSubString
              mainString={searchTerm.value}
              subString={query}
            />
          </AutoSuggestListItem>
        ))}
      </AutoSuggestList>
    </AutoSuggestSection>
  );
};

TopSuggestionsSection.propTypes = {
  query: PropTypes.string,
  suggestions: PropTypes.array,
};

export default TopSuggestionsSection;
